<template>
  <v-hover v-slot="{ hover }">
    <v-sheet
      :width="width"
      :height="height"
      :min-width="minWidth"
      :min-height="minHeight"
    >
      <div
        v-if="!fileUrl || !enablePreview"
        class="file-uploader--uploader"
        @click="browseFiles"
      >
        <div class="d-flex align-center mb-2">
          <v-icon color="primary" left>mdi-cloud-upload</v-icon>
          <h2>Upload File</h2>
        </div>
        <div
          v-show="placeholder"
          class="text-subtitle-2 text-center"
          style="word-break: break-word"
        >
          {{ placeholder }}
        </div>
      </div>
      <div v-else-if="loading" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-img
        v-else-if="isPreviewImage"
        class="file-uploader--image-preview"
        contain
        width="100%"
        height="100%"
        :src="fileUrl"
        @click="browseFiles"
      >
        <v-fade-transition>
          <v-overlay v-if="hover && overlayDownload" absolute color="#036358">
            <v-btn>
              <a :href="fileUrl" target="_blank">Open Image</a>
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-img>
      <div v-else class="file-uploader--file-preview" @click="browseFiles">
        <v-icon x-large>mdi-file</v-icon>
        <div>{{ fileName }}</div>
      </div>
      <input
        v-show="false"
        ref="input"
        :disabled="disabled"
        type="file"
        :accept="accept"
        @change="uploadFiles($event)"
      />
      <v-overlay
        v-if="!disabled && overlayMenu"
        :value="hover"
        absolute
        class="file-uploader--overlay-menu"
      >
        <slot name="overlay-menu">
          <v-container fluid class="fill-height py-0">
            <v-row class="fill-height align-center">
              <v-col cols="12" class="text-center">
                <div style="cursor: pointer" @click="browseFiles">
                  Click to Change File
                </div>
              </v-col>
            </v-row>
          </v-container>
        </slot>
      </v-overlay>
      <slot name="message"></slot>
    </v-sheet>
  </v-hover>
</template>

<script>
import FileType from 'file-type/browser'
// import { fileTypeFromStream, fileTypeFromBlob } from 'file-type'
import VInput from 'vuetify/lib/components/VInput/VInput'
export default {
  name: 'FileUploader',
  extends: VInput,
  props: {
    value: {
      type: [String, File],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '150',
    },
    minWidth: {
      type: [Number, String],
      default: '150',
    },
    minHeight: {
      type: [Number, String],
      default: '150',
    },
    accept: {
      type: String,
      default: null,
    },
    enablePreview: {
      type: Boolean,
      default: true,
    },
    overlayMenu: {
      type: Boolean,
      default: false,
    },
    overlayDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagePreview: null,
      fileUrl: null,
      fileName: null,
      fileMime: null,
    }
  },
  computed: {
    isImage() {
      return this.fileMime && /image/i.test(this.fileMime)
    },
    isPreviewImage() {
      return this.enablePreview && this.isImage
    },
  },
  watch: {
    value(newValue) {
      this.detectFile(newValue)
    },
  },
  created() {
    this.detectFile(this.value)
  },
  methods: {
    convertToUnit(unitValue, unit = 'px') {
      if (unitValue == null || unitValue === '') {
        return undefined
      } else if (isNaN(unitValue)) {
        return unitValue
      } else {
        return `${unitValue}${unit}`
      }
    },
    browseFiles() {
      if (!this.disabled) {
        this.$refs.input.click()
      }
    },
    uploadFiles(event) {
      if (event.target.files != null && event.target.files.length > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.fileUrl = e.target.result
        }
        reader.readAsDataURL(event.target.files[0])
        this.$emit('input', event.target.files[0])
      }
    },
    async detectFile(value) {
      let fileType = null
      if (value instanceof File) {
        console.log('fromFile')
        this.fileName = value.name
        const reader = new FileReader()
        reader.onload = (e) => {
          this.fileUrl = e.target.result
        }
        reader.readAsDataURL(value)
        fileType = await FileType.fromBlob(value)
        // fileType = await fileTypeFromBlob(value)
      } else if (typeof value === 'string' || value instanceof String) {
        console.log(`fromUrl: ${this.fileUrl}`)
        this.fileUrl = value
        this.fileName = value.substring(value.lastIndexOf('/') + 1)
        const response = await fetch(value)
        fileType = await FileType.fromStream(response.body)
        // fileType = await fileTypeFromStream(response.body)
      }
      if (fileType) {
        this.fileMime = fileType.mime
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~/sass/_colors.scss';
.file-uploader {
  &--uploader {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: map-get($colors, 'primary-light');
    color: map-get($colors, 'primary');
    cursor: pointer;
    border-color: map-get($colors, 'primary');
    border-style: dashed;
    border-width: 4px;
    border-radius: 8px;
    padding: 8px;
    line-height: 1.8;
  }
  &--image-preview {
    background-color: #f5f5f7;
    border-radius: 8px;
  }
  &--file-preview {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    cursor: pointer;
    padding: 8px;
    line-height: 1.8;
  }
  &--overlay-menu {
    & :deep(.v-overlay__content) {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>
